module.exports = __webpack_public_path__ + "media/svg/sm-551aef16.svg";